export const PUBLIC_URL = process.env.PUBLIC_APP_URL
export const S3_BUCKET = process.env.S3_BUCKET
export const AMAZON_AWS_IMAGE_URL =
  process.env.APP_ENV === 'production'
    ? 'https://unbridaled-prod.s3.amazonaws.com/das/static/images'
    : 'https://unbridaled-dev.s3.amazonaws.com/das/static/images'
